<div class="flex flex-col -m-6">

    <!-- Header -->
    <div
        class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'goal.createGoal' | transloco }}</div>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex flex-col sm:flex-row items-center p-2 sm:p-8 sm:items-start w-full">
        <dtype-component-list class="w-full" [dtypeForm]="dTypeForm" [isUpdate]="data.update">
        </dtype-component-list>
    </div>

    <!-- Actions -->
    <div class="flex flex-col sm:flex-row justify-end gap-2 px-4 pb-2 sm:px-8 sm:pb-8 w-full">
        <button (click)="closeDialog()" mat-stroked-button>
            {{ 'cancel' | transloco }}
        </button>
        <button (click)="save()" mat-flat-button color="primary">
            {{ 'save' | transloco }}
        </button>
    </div>
</div>